import { render, staticRenderFns } from "./SyncBackModal.vue?vue&type=template&id=7d496790&scoped=true"
import script from "./SyncBackModal.vue?vue&type=script&lang=js"
export * from "./SyncBackModal.vue?vue&type=script&lang=js"
import style0 from "./SyncBackModal.vue?vue&type=style&index=0&id=7d496790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d496790",
  null
  
)

export default component.exports